/* External dependencies */
import { gql } from '@apollo/client';

/* Local dependencies */
import { setAuthenticatedClient } from '../../../../client/graphql';
import { UpdateDeviceInput, Device } from '../../types';

const UPDATE_DEVICE = gql`
  mutation UpdateDevice($input: T26UpdateDeviceInput!) {
    T26UpdateDevice(input: $input) {
      id
      address
      comment
      deviceLocation {
        lat
        lon
      }
      isVerified
      paymentService
      registrationDate
      user {
        id
      }
    }
  }
`;

export const updateDeviceRequest = async (input: UpdateDeviceInput): Promise<Device> => {
  try {
    const client = await setAuthenticatedClient();
    const response = await client.mutate({
      mutation: UPDATE_DEVICE,
      variables: { input },
    });
    console.log('Device updated: ', response.data.T26UpdateDevice);
    return response.data.T26UpdateDevice;
  } catch (err) {
    console.error('Error updating device:', err);
    throw err;
  }
}; 